// Maps the backend recliner-count selection ("2 Recliner"/"3 Recliner") to Cylindo's
// POWER OPTIONS code. Returns null for anything Cylindo doesn't list, so a count the
// backend offers but Cylindo can't render just no-ops. JB sku is "-2RECLINER", Cylindo
// code is "2 RECLINER", so match on name first then fall back to the uppercased value.
const resolveCylindoPowerOptionsCode = ({
  jbSku,
  jbName,
  cylindoOptions,
} = {}) => {
  if (!Array.isArray(cylindoOptions) || cylindoOptions.length === 0) {
    return null;
  }

  const normalizedName = (jbName || '').trim();
  if (normalizedName) {
    const lowerName = normalizedName.toLowerCase();
    const byName = cylindoOptions.find(
      opt =>
        (opt.name || '').trim().toLowerCase() === lowerName ||
        (opt.code || '').trim().toLowerCase() === lowerName
    );
    if (byName) return byName.code;
  }

  // Fallback: Cylindo's code is the uppercased display value ("2 Recliner" -> "2 RECLINER").
  const uppercaseValue = normalizedName.toUpperCase();
  if (uppercaseValue) {
    const byUppercase = cylindoOptions.find(
      opt => (opt.code || '').trim().toUpperCase() === uppercaseValue
    );
    if (byUppercase) return byUppercase.code;
  }

  // Last resort: normalize the sku ("-3RECLINER" -> "3 RECLINER") and match the code.
  const skuAsCode = (jbSku || '')
    .replace(/^-/, '')
    .replace(/^(\d+)/, '$1 ')
    .trim()
    .toUpperCase();
  if (skuAsCode) {
    const bySku = cylindoOptions.find(
      opt => (opt.code || '').trim().toUpperCase() === skuAsCode
    );
    if (bySku) return bySku.code;
  }

  return null;
};

export default resolveCylindoPowerOptionsCode;
